import dayjs from "dayjs";
import { formatDateRange, formatRecordValue } from "@/util/recordUtils.js";
import { Entry, EntryRecord } from "@/types/entry.ts";
import { RecordColumnDocument } from "@/types/category.ts";

export function mapItemToRecord(
  entryItem: Entry,
  recordColumn: RecordColumnDocument,
  index: number
): EntryRecord | undefined {
  if (typeof entryItem.recordInfo === "undefined") {
    return undefined;
  }
  return {
    recordInfo: entryItem.recordInfo,
    rank: index + 1,
    name: entryItem.recordInfo.name,
    year: entryItem.recordInfo.recordDate
      ? dayjs(entryItem.recordInfo.recordDate).format(
          entryItem.recordInfo.recordDate.includes("01-01")
            ? "YYYY"
            : "MMMM D, YYYY"
        )
      : "",
    yearRange: formatDateRange(
      entryItem.recordInfo.yearStart,
      entryItem.recordInfo.yearEnd
    ),
    value: formatRecordValue(
      recordColumn.recordType,
      entryItem.recordInfo.recordValue
    ),
    extraInfo1: entryItem.recordInfo.primaryInfo,
    extraInfo2: entryItem.recordInfo.extraInfo,
    path: entryItem.path,
    units: recordColumn.recordUnits,
    recordImage:
      entryItem.recordInfo.recordImage &&
      entryItem.recordInfo.recordImage.length
        ? entryItem.recordInfo.recordImage[0].url
        : "",
    recordImageAlt:
      entryItem.recordInfo.recordImage &&
      entryItem.recordInfo.recordImage.length
        ? entryItem.recordInfo.recordImage[0].metadata?.description
        : "",
    videos: entryItem.media
      .filter((item) => item.type === "video")
      .map((item) => ({
        url: item.url,
        caption: item.metadata?.description || "",
        isVideo: item.type === "video",
        isExternal: item.isExternal,
        metadata: item.metadata,
        id: item._id,
      })),
  };
}
